import { render, staticRenderFns } from "./StyleDialogLabelsTab.vue?vue&type=template&id=2a9ebfee&scoped=true&"
import script from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogLabelsTab.vue?vue&type=style&index=0&id=2a9ebfee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ebfee",
  null
  
)

export default component.exports